import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AppProviders from "./AppProviders";
import { cdnAsset } from './utils/cdn';
const favicon = cdnAsset('logo.svg');

// Ensure favicon uses the app logo from assets
const ensureFavicon = () => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
  link.type = "image/svg+xml";
  link.rel = "icon";
  link.href = favicon;
  if (!link.parentNode) document.head.appendChild(link);
};
ensureFavicon();

const root = ReactDOM.createRoot(document.getElementById("root"));

// Note: React.StrictMode intentionally removed to prevent double API calls in development
// StrictMode double-invokes effects which causes duplicate network requests
root.render(
  <AppProviders>
    <App />
  </AppProviders>
);
